import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { fetchData } from "./Utilities";
import { logoutStatic } from "../../StateManagement/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const ConvertRlsToCoinModal = ({
  isOpen,
  closeModal,
  onExit,
  onExited,
  userId,
}) => {
  const [checkLogin, setCheckLogin] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [errorMessage, setErrorMessage] = useState(null);
  const [coin, setCoin] = useState({ value: 0, error: null });
  const saveCoins = async () => {
    if (!coin.value) {
      setCoin({ value: coin.value, error: "لطفا مقدار ریالی را وارد نمایید." });
      return;
    }
    setCoin({ value: coin.value, error: "" });
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("rls", coin.value);
    fetchData("convertrlstocoin", bodyFormData, handleApiResponse);
  };
  const handleApiResponse = (data) => {
    setCheckLogin(data?.UserId);
    closeModal();
    SweetAlert({
      title: "",
      text: data,
      type: "success",
    });
  };
  useEffect(() => {
    if (checkLogin === "0") {
      dispatch(logoutStatic());
      navigate("/");
    }
  }, [checkLogin]);
  return (
    <Modal
      show={isOpen}
      onHide={closeModal}
      onExit={onExit}
      onExited={onExited}
      centered
    >
      <Modal.Header>
        <div className="m-auto maxh-20 fw-bold text-secondary ">
          تبدیل ریال به سکه پارسی
        </div>

        <button
          className="btn-close bg-danger text-white"
          onClick={() => closeModal()}
        />
      </Modal.Header>
      <Modal.Body
        className="justify-content-center mx-4
            "
      >
        <Form.Group className="mb-3 w-75">
          <Form.Label className="fw-bold pb-1">
            مقدار ریالی برای تبدیل به سکه پارسی را وارد نمایید
          </Form.Label>
          <Form.Control
            type="number"
            onChange={(e) => setCoin({ value: e.target.value, error: "" })}
          />
          {coin.error && (
            <p className="text-danger text-center">{coin.error}</p>
          )}
        </Form.Group>
      </Modal.Body>
      {errorMessage && (
        <p className="text-danger text-center">{errorMessage}</p>
      )}
      <Modal.Footer className="justify-content-center">
        <Button variant="primary" onClick={() => saveCoins()}>
          ذخیره
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ConvertRlsToCoinModal;
